import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';

import {
  CorreoElectronico,
  createCorreoElectronico,
  CurrentEmpresa
} from '@rpe/registro-personas-empresas-lib';

import { selectCurrentEmpresa } from '../../empresas/entity-mis-empresas/entity-current-empresa.selectors';
import { DireccionesGeograficasFormComponent } from '../../ubicaciones/direcciones-geograficas/direcciones-geograficas-form/direcciones-geograficas-form.component';
import { State } from '../../vista-usuario/vista-usuario.state';
import {
  createDeposito,
  createEmptyDeposito,
  Deposito,
  DepositosFormInput
} from '../entity-depositos/depositos.model';
import { DatosContactoFormComponent } from '../../contactos/datos-contacto/datos-contacto-form/datos-contacto-form.component';

import {
  createDatosContacto,
  DatosContacto
} from '../../contactos/datos-contacto/datos-contacto.model';
import { DireccionGeografica } from '../../ubicaciones/direcciones-geograficas/direcciones-geografica.model';

@Component({
  selector: 'rpe-registro-actividad-almacenamiento',
  templateUrl: './registro-actividad-almacenamiento-form.component.html',
  styleUrls: ['./registro-actividad-almacenamiento-form.component.scss']
})
export class RegistroActividadAlmacenamientoFormComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @Input() index = 0;

  @Input() set formInput(d: Deposito) {
    if (d && this.primeraVez) {
      this._deposito = d;
    }

    if (!d && this.primeraVez) {
      this._deposito = createEmptyDeposito();
    }

    if (this.primeraVez) {
      this.setForm();
    }

    this.primeraVez = false;
  }

  get formInput(): Deposito {
    return this._deposito;
  }

  @Output() newDeposito = new EventEmitter<boolean>();
  @Output() formStatusChanges = new EventEmitter<string>();
  @Output() formValueChanges = new EventEmitter<Deposito>();

  // Datos de contacto
  @ViewChild(DatosContactoFormComponent, { static: true })
  datosContactoForm: DatosContactoFormComponent;

  datosContactoFormInput: DatosContacto = null;
  datosContacto: DatosContacto;
  datosContactoStatus: string;

  // Direccion geografica
  @ViewChild(DireccionesGeograficasFormComponent)
  direccionGeograficaForm: DireccionesGeograficasFormComponent;

  direccionGeograficaFormInput: DireccionGeografica = null;
  direccionGeografica: DireccionGeografica;
  direccionGeograficaValid: string;

  _depositosFormInput: DepositosFormInput;
  empresa$: Observable<CurrentEmpresa>;
  subscriptions: Subscription[] = [];
  primeraVez: boolean = true;

  isLoaded = false;

  depositos$: Observable<Deposito[]>;
  _deposito: Deposito;

  registroActividadAlmacenamientoFormGroup: FormGroup = this.fb.group({
    id: [null, []],
    nombre: [null, [Validators.required]],
    entidad_productiva_id: [null, [Validators.required]]
  });

  constructor(private fb: FormBuilder, private store: Store<State>) {}

  ngOnInit(): void {
    this.empresa$ = this.store.select(selectCurrentEmpresa);
    const s1 = this.empresa$.subscribe((e) => {
      this.registroActividadAlmacenamientoFormGroup.patchValue({
        entidad_productiva_id: e.id
      });
    });

    // emit events
    const s2 =
      this.registroActividadAlmacenamientoFormGroup.valueChanges.subscribe(
        (_) => {
          const d = this.creoDeposito();
          this.formValueChanges.emit(d);
        }
      );

    const s3 =
      this.registroActividadAlmacenamientoFormGroup.statusChanges.subscribe(
        (f) => {
          const s = this.onlyValid(
            f,
            this.datosContactoStatus,
            this.direccionGeograficaValid
          );
          this.formStatusChanges.emit(s);
        }
      );

    this.subscriptions.push(s1, s2, s3);
  }

  ngAfterViewInit() {
    this.isLoaded = true;
  }

  setForm() {
    // Form
    this.registroActividadAlmacenamientoFormGroup.patchValue(
      {
        id: this._deposito.id,
        nombre: this._deposito.nombre,
        entidad_productiva_id: this._deposito.entidad_productiva_id
      },
      { emitEvent: false }
    );
    // Direccion geografica
    this.direccionGeografica = { ...this._deposito.direccion_geografica };
    this.direccionGeograficaFormInput = this.direccionGeografica;
    // Contacto
    this.datosContacto = createDatosContacto({
      telefonos: this._deposito.telefonos,
      correos_electronico: this._deposito.correos_electronico
    });

    this.datosContactoFormInput = this.datosContacto;
  }

  onlyValid(a: string, b: string, c: string): string {
    let r = 'ERROR';
    if (a === 'VALID' && b === 'VALID' && c === 'VALID') {
      r = 'VALID';
    }
    return r;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  // Datos contacto
  datosContactoChange(dc: DatosContacto) {
    this.datosContacto = dc;
    const d = this.creoDeposito();

    this.formValueChanges.emit(d);
  }

  datosContactoStatusChange(s: string) {
    this.datosContactoStatus = s;
    const status = this.onlyValid(
      this.registroActividadAlmacenamientoFormGroup.status,
      this.datosContactoStatus,
      this.direccionGeograficaValid
    );
    this.formStatusChanges.emit(status);
  }

  onShowErrors(): void {
    this.registroActividadAlmacenamientoFormGroup.markAllAsTouched();
    this.datosContactoForm?.checkErrors();
    this.direccionGeograficaForm?.checkErrors();
  }

  // Direccion Geografica
  direccionGeograficaChange(dg: any) {
    console.log(dg, 'estadoDepo');
    this.direccionGeografica = dg;

    const d = this.creoDeposito();
    this.formValueChanges.emit(d);
  }

  direccionGeograficaStatusChange(s: string) {
    console.log(s, 'estadoDepo');
    this.direccionGeograficaValid = s;
    const status = this.onlyValid(
      this.registroActividadAlmacenamientoFormGroup.status,
      this.direccionGeograficaValid,
      this.datosContactoStatus
    );
    this.formStatusChanges.emit(status);
  }

  checkChildrens() {
    this.direccionGeograficaForm.checkErrors();
    this.datosContactoForm.checkErrors();
  }

  creoDeposito(): Deposito {
    // agrego correos
    let correos: CorreoElectronico[] = [];
    if (this.datosContacto?.correos_electronico) {
      this.datosContacto.correos_electronico.forEach((c) => {
        correos.push(
          createCorreoElectronico({
            id: c.id,
            direccion: c.direccion,
            tipo_correo_id: 1
          })
        );
      });
    } else {
      correos = null;
    }
    const d = createDeposito({
      ...this.registroActividadAlmacenamientoFormGroup.value,
      correos_electronico: correos,
      telefonos: this.datosContacto?.telefonos,
      direccion_geografica: this.direccionGeografica
    });
    return d;
  }

  onSave() {
    this.checkChildrens();
    if (
      this.registroActividadAlmacenamientoFormGroup.valid
      // && this.datosContactoValid && this.direccionGeograficaValid
    ) {
      const d = this.creoDeposito();

      // this.saveDeposito.emit(d);
    }
  }

  agregarNuevoDeposito() {
    this.newDeposito.emit(true);
  }

  eliminarDeposito() {
    this.newDeposito.emit(false);
  }
}
